module.exports = __webpack_public_path__ + "static/media/x-symbol.d5ec64e8.svg";